<div class="notification-center">
  <h1
    class="title"
    [id]="isPopover() ? 'notification-popover-title' : null"
    [class.typography-h3]="!isPopover()"
    [class.typography-h3-medium]="isPopover()"
  >
    {{ titleKey() | translate }}
  </h1>

  <section class="card">
    <header class="tabs">
      <app-nav-tab [tabs]="tabs()" />
      @if (showMarkAllButton()) {
      <button
        app-button
        class="mark-all"
        variant="secondary"
        iconPath="assets/icons/check_2.svg"
        [disabled]="markingAllAsRead() || loading() || unreadCount() === 0"
        [loading]="markingAllAsRead()"
        (click)="markAllAsRead.emit()"
      >
        {{ 'NOTIFICATION_CENTER_MARK_ALL_READ' | translate }}
      </button>
      }
    </header>

    <div class="content" [class.empty-content]="!loading() && !error() && groups().length === 0">
      @if (loading()) {
      <div class="skeleton-groups skeleton-list" aria-hidden="true">
        @for (group of skeletonGroups; track $index) {
        <section class="notification-group">
          <app-skeleton-block class="date" width="80px" height="16px" />
          <div class="items">
            @for (item of group; track $index) {
            <app-notification-item [loading]="true" />
            }
          </div>
        </section>
        }
      </div>
      } @else if (error()) {
      <div class="empty error">
        <app-icon class="icon" path="assets/icons/no_notification.svg" [size]="56" aria-hidden="true" />
        <p class="message typography-body-regular">
          {{ 'ERROR_SITES_TAKES_TO_LONG_TO_LOAD_OR_UNAVAILABLE' | translate }}
        </p>
        <button app-button variant="secondary" (click)="retry.emit()">{{ 'RETRY' | translate }}</button>
      </div>
      } @else { @for (group of groups(); track group.date) {
      <section class="notification-group">
        <h2 class="date typography-body-regular">{{ group.date | format: { type: 'dayMonth' } }}</h2>
        <div class="items">
          @for (notification of group.notifications; track notification.id) {
          <app-notification-item
            [type]="notification.type"
            [params]="notification.params ?? {}"
            [message]="notification.message"
            [actionKey]="notification.actionKey"
            (action)="open.emit(notification)"
          />
          }
        </div>
      </section>
      } @empty {
      <div class="empty">
        <app-icon class="icon" path="assets/icons/no_notification.svg" [size]="56" aria-hidden="true" />
        <p class="message typography-body-regular">{{ emptyMessageKey() | translate }}</p>
      </div>
      } }
    </div>
  </section>

  @if (isPopover()) {
  <footer class="footer">
    <a app-button class="open-center" variant="subtle" routerLink="/notifications" (click)="openCenter.emit()">
      {{ 'NOTIFICATION_POPOVER_OPEN_CENTER' | translate }}
    </a>
  </footer>
  }
</div>
